import { Skeleton } from 'components';

const ArticleSkeleton = () => {
  return (
    <>
      <Skeleton type="text" size="initial" classNames="h-4 w-96 mb-4" />
      <div className="flex justify-between items-center">
        <Skeleton type="text" size="initial" classNames="h-8 w-80 hidden lg:block mb-14" />
        <div className="hidden lg:flex items-center gap-2">
          <Skeleton type="square" />
          <Skeleton type="square" />
        </div>
      </div>

      <Skeleton type="square" size="initial" classNames="my-12 hidden lg:block h-64 w-full" />
      <div className="flex flex-col lg:hidden mb-12">
        <Skeleton type="text" size="initial" classNames="h-8 w-80" />
        <Skeleton type="text" size="initial" classNames="h-8 w-40" />
      </div>

      <div className="flex gap-x-16">
        <div className="flex flex-col gap-8 flex-grow">
          <div className="flex flex-col gap-4">
            <Skeleton type="text" size="initial" classNames="h-6 w-80" />
            <div>
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-2/3" />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Skeleton type="text" size="initial" classNames="h-6 w-80" />
            <div>
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-2/3" />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Skeleton type="text" size="initial" classNames="h-6 w-80" />
            <div>
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-2/3" />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <Skeleton type="text" size="initial" classNames="h-6 w-80" />
            <div>
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-full" />
              <Skeleton type="text" size="initial" classNames="h-4 w-2/3" />
            </div>
          </div>
        </div>

        <div className="hidden lg:flex flex-col gap-y-6">
          <Skeleton type="square" classNames="w-60 h-60" size="initial" />
          <Skeleton type="square" classNames="w-60 h-60" size="initial" />
        </div>
      </div>
    </>
  );
};

export default ArticleSkeleton;
